import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { formatLocal } from '../../utils/vinExtraction';
import { infoBoxStyle, monoTextStyle } from './vinExtractionStyles';
import NoValue from './NoValue';
import CarInfoRow from './CarInfoRow';

/**
 * Stock number, the batch's creation time and the Current VIN (`a1_cars.vin`), each with a named placeholder, plus the
 * VIN the car had before this batch when it had one.
 */
const CarInfo = ({ car, batch }) => {
    const { t, i18n } = useTranslation('vinExtraction');

    return (
        <Flex vertical gap={spacing[0.5]} style={infoBoxStyle}>
            <CarInfoRow label={t('drawer.stockNo')}>
                {car.stockNumber ?? <NoValue label={t('cars.noStockNo')} />}
            </CarInfoRow>
            <CarInfoRow label={t('drawer.batch')}>
                {batch ? (
                    formatLocal(batch.createdAt, 'DD MMM YYYY, HH:mm', i18n.language)
                ) : (
                    <NoValue label={t('drawer.batch')} />
                )}
            </CarInfoRow>
            <CarInfoRow label={t('drawer.currentVin')}>
                {car.vin ? <span style={monoTextStyle}>{car.vin}</span> : <NoValue label={t('cars.noVin')} />}
            </CarInfoRow>
            {car.previousVin && (
                <CarInfoRow label={t('drawer.previousVin')}>
                    <span style={monoTextStyle}>{car.previousVin}</span>
                </CarInfoRow>
            )}
        </Flex>
    );
};

export default CarInfo;
